import React from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';

interface Props {
    to: string;
    replace?: boolean;
    state?: any;
}

const ParamsNavigate = ({ to, replace, state }: Props) => {
    const params = useParams();
    const redirectWithParams = generatePath(to, params);

    return <Navigate to={redirectWithParams} replace={replace} state={state} />;
};

export default ParamsNavigate;
